//八大员后台
// const prefix = "https://hbjzpxgl.cj-edu.com/jxjy-service/";//线上的
// const prefix = "http://192.168.0.111:35049/jxjyService";//本地的
// const prefix = "http://127.0.0.1:4523/m1/2605734-0-default/jxedu";
// const prefix = "http://192.168.0.122:35049/jxjyService";
// const prefix = "http://127.0.0.1:4523/m1/2605734-0-default";
const prefix = process.env.NODE_ENV === "production" ? "https://hbjzpxgl.cj-edu.com/jxjy-service" : "http://192.168.110.111:35049/jxjy-service";
export default {
    BASEURL: prefix,
    DEBUG: false,
    UPDATE_PWD: `${prefix}/sysUser/updatePwd`,//修改密码
    LOGIN: {
        passwordLogin: `${prefix}/sysUser/login`, //登录
        getValidateCodeImg: () => `${prefix}/system/validateCode/${new Date().getTime()}?width=155&height=60`,//登录验证码的地址
        getNowTime: `${prefix}/getNowTime`, //获取系统时间
        getAuthorityMenu: `${prefix}/sysUser/permissionList`,//获取权限菜单
        logout: `${prefix}/sysUser/logOut`, //退出登录
    },
    UPLOAD: `${prefix}/system/upload/file2`,//文件上传
    UPLOAD_base64: `${prefix}/system/upload/Base64Image`,//手动上传，base64格式
    AUTHORITY: {//权限相关
        //角色
        C_role: `${prefix}/system/role/add`,//增
        D_role: `${prefix}/system/role/delete`,//删
        U_role: `${prefix}/system/role/update`,//改
        R_role: `${prefix}/system/role/list`,//查
        R_role_one: `${prefix}/system/role/info`,//查一个
        R_permission_menuList: `${prefix}/sysUser/permissionList`,//获取用户的权限列表
        R_allAuthority_menuList: `${prefix}/system/menu/list`,//所有的权限菜单
        //菜单
        C_menu: `${prefix}/system/menu/add`,//增
        R_menu: `${prefix}/system/menu/list`,//查
        U_menu: `${prefix}/system/menu/update`,//改
        D_menu: `${prefix}/system/menu/delete`,//删
        //用户
        C_user: `${prefix}/sysUser/addNew`,//增
        D_user: `${prefix}/sysUser/delete`,//删
        U_user: `${prefix}/sysUser/infoUpdate`,//改
        R_user: `${prefix}/sysUser/list`,//查
        R_user_one: `${prefix}/system/person/info`,//查一个，获取个人信息详情
        F_user: `${prefix}/sysUser/forbiden`,//用户禁用
        resetPwd: `${prefix}/sysUser/resetPwd`,//密码重置
        currentUser_roleList: `${prefix}/sysUser/roleList`,//获取当前用户对应的角色列表
        saveUserRole: `${prefix}/sysUser/userRole`,//保存用户角色设置
        //部门
        C_dept: `${prefix}/system/dept/add`,//增
        D_dept: `${prefix}/system/dept/delete`,//删
        U_dept: `${prefix}/system/dept/update`,//改
        R_dept: `${prefix}/system/dept/list`,//查
        //系统设置
        R_config: `${prefix}/system/config/list`,//查
        CU_config: `${prefix}/system/config/add`,//增
        G_config: `${prefix}/system/config/all`,//全部系统设置接口
        R_config_one: `${prefix}/system/config/info`,//查询系统设置项信息
    },
    STUDENT: {//学生和班级相关
        //【课程分类】
        C_courseCategory: `${prefix}/system/courseCategory/add`,//增
        D_courseCategory: `${prefix}/system/courseCategory/delete`,//删
        U_courseCategory: `${prefix}/system/courseCategory/update`,//改
        R_courseCategory: `${prefix}/system/courseCategory/list`,//查
        //【学科专业】
        C_eduMajor: `${prefix}/system/edu/major/add`,//增
        D_eduMajor: `${prefix}/system/edu/major/delete`,//删
        U_eduMajor: `${prefix}/system/edu/major/update`,//改
        R_eduMajor: `${prefix}/system/edu/major/list`,//查
        //【教师管理】
        CU_teacher: `${prefix}/system/teacher/add`,//增改
        R_teacher: `${prefix}/system/teacher/list`,//查
        R_teacher_one: `${prefix}/system/teacher/info`,//获取单个教师信息
        S_teacher: `${prefix}/system/teacher/indexShow`,//首页推荐或不推荐
        //【课程管理】
        C_course: `${prefix}/system/course/add`,//增
        U_course: `${prefix}/system/course/update`,//改课程基础信息
        U_course_chapter: `${prefix}/system/course/chapter/update`,//修改课程的章节信息
        R_course: `${prefix}/system/course/list`,//查，课程列表
        R_course_one: `${prefix}/system/course/info`,//查，一条课程详情
        C_calDuration: `${prefix}/system/course/chapter/calDuration`,//计算时长
        R_course_chapter: `${prefix}/system/course/chapter/info`,//查，一条课程章节信息
        Course_recommend: `${prefix}/system/course/recommend`,//首页推荐
        Course_unRecommend: `${prefix}/system/course/unRecommend`,//取消首页推荐
        //【班级管理】
        C_class: `${prefix}/system/class/add`,//增
        D_class: `${prefix}/system/class/delete`,//删
        U_class: `${prefix}/system/class/update`,//改
        R_class: `${prefix}/system/class/list`,//查
        R_class_one: `${prefix}/system/class/info`,//查一个
        C_class_student_add: `${prefix}/system/class/addStudent`,//班级学生新增接口
        D_class_student_delete: `${prefix}/system/class/removeStudent`,//班级学生删除接口
        //【学生管理】
        R_student: `${prefix}/system/student/list`,//查，学生管理列表
        R_student_format: `${prefix}/system/student/list2`,//查，用于班级管理>班级学生设置的左侧表回显
        CU_student: `${prefix}/system/student/add`,//增改
        I_student: `${prefix}/system/student/importByExcel`,//批量导入学生
        I_studentPhoto: `${prefix}/system/student/importByZip`,//批量导入学生照片
        I_studentCourseExcel: `${prefix}/system/class/student/importCourseExcel`,//批量刷课
        D_student: `${prefix}/system/student/delete`,//删
        R_student_one: `${prefix}/system/student/info`,//查一个
        P_student: `${prefix}/system/student/resetPwd`,//学生重置密码
        F_student: `${prefix}/system/student/faceImageCheck`,//人脸信息审核
        CC_student: `${prefix}/system/student/cardCheck`,//实名身份信息审核
        //【批次学生管理】
        R_class_student: `${prefix}/system/class/student/list`,//班级学生列表
        R_class_tree: `${prefix}/system/class/tree`,//获取班级的树
        G_class: `${prefix}/system/class/student/graduate`,//结业
        G_class_un: `${prefix}/system/class/student/unGraduate`,//撤销结业
        P_student_info: `${prefix}/system/class/student/studyInfo`,//班级学生课程学习情况
        D_classStuDownload: `${prefix}/system/class/student/exportToExcel`,//导出
        R_class_student_brush: `${prefix}/system/class/student/studySchedule`,//刷课
        // 【友情链接管理】
        R_friendLink: `${prefix}/system/friendLink/list`,//查
        CU_friendLink: `${prefix}/system/friendLink/add`,//增改
        D_friendLink: `${prefix}/system/friendLink/delete`,//删
        R_friendLink_one: `${prefix}/system/friendLink/info`,//查一个
        // 【系统导航管理】
        R_system_navList: `${prefix}/system/nav/list`,//查
        CU_system_navList: `${prefix}/system/nav/add`,//增改
        E_system_navList: `${prefix}/system/nav/enable`,//启用系统导航
        D_system_navList: `${prefix}/system/nav/disable`,//禁用系统导航
        R_system_navList_one: `${prefix}/system/nav/info`,//查一个
        // 【文章发布】
        R_news_categoryList: `${prefix}/system/news/categoryList`,//查文章分类列表
        R_news_List: `${prefix}/system/news/list`,//查文章列表
        CU_news_List: `${prefix}/system/news/add`,//增改文章
        D_news_list: `${prefix}/system/news/delete`,//删
        R_news_List_one: `${prefix}/system/news/info`,//查一个
        // 【系统消息】
        R_system_message: `${prefix}/system/message/list`,//查
        C_system_message: `${prefix}/system/message/add`,//增
        D_system_message: `${prefix}/system/message/cancelMsg`,//消息撤回
        //【学生抓拍查看】
        R_student_capture: `${prefix}/student/face/recordList`,//查
        // 学员批次管理
        R_student_batch: `${prefix}/system/batch/list`,//查
        R_student_batch_time: `${prefix}/system/batch/setDate`,//查
    },

};





// WEBPACK FOOTER //
// ./src/api/model/serverApi.js